import {
    ITPMEventSpend,
    ITPMEventSpendChangedEvent,
    ITPMEventSpendProductChangedEvent,
    ITPMEventSpendProductGroupChangedEvent,
    ITPMEventSpendProductGroups, ITPMEventSpendProductGroupsAddOptions,
    ITPMEventSpendProducts,
    ITPMEventSpendProductsAddOptions,
    ITPMEventSpendProductsAddOptionsDefaults
} from "../PA.TPM.Core/PA.TPM.IF.TPM.EventSpend.Aspects";
import {
    WB_FinishedProductRow,
    WB_ProductGroupRow,
    WB_TPM_EventSpendPrdGrpRow,
    WB_TPM_EventSpendPrdRow,
    WB_TPM_EventSpendRow
} from "../PA.Core/PAdbSchemaRows";
import { BehaviorSubject } from "rxjs";
import { TPMEventBO } from "./TPMEventBO";
import { utils } from "js-data";
import * as _ from "lodash";
import {
    esWB_Finished_Product,
    esWB_Product_Group,
    esWB_TPM_Event_Spend_Product,
    esWB_TPM_Event_Spend_Product_Group
} from "../PA.Core/PAdbSchema";
import { ASync } from "../PA.Core/Basic/ASync";
import { IHaveSecurity } from "../PA.Core/PA.Core.IF.Aspects";
import { IPolicyCollection } from "../PA.Core/PA.Core.IF.Policy";
import { PolicyCollection } from "../PA.Core/Security/PolicyCollection";
import { TPMEventBOStandardSpendPolicy } from "./TPMEventBO.StdSpendPolicy";
import { IHaveWorkflow, IWorkflowProcessor } from "../PA.Core/PA.Core.IF.Workflow";
import { WorkflowProcessor } from "../PA.Core/Workflow/WorkflowProcessor";
import { TPMEventBOStandardSpendWorkflowExtension } from "./TPMEventBO.StdSpendWorkflowExt";
import { IMessageProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { MessageProvider } from "../PA.Core/Basic/Messages";
import { TPMEventBOStandardPolicy } from "./TPMEventBO.StdPolicy";
import { PaymentMethod_OffInvoice } from "../PA.TPM.Core/TPM.Constants";
import { TPMEventSpendValidations } from "./TPMEventBO.ITPMEventSpend.validations";


export class TPMEventSpend
    implements ITPMEventSpend,
        ITPMEventSpendProductGroups,
        ITPMEventSpendProducts,
        IHaveSecurity,
        IHaveWorkflow {
    private _OnLoadComplete: Promise<void>
    private _bIsLoaded: boolean
    private _TPMEventSpendRow: WB_TPM_EventSpendRow
    private _TPMEventBO: TPMEventBO
    private _TPMEventSpendPropertyChanged: BehaviorSubject<ITPMEventSpendChangedEvent>;
    private _ValidateMessageProvider: MessageProvider
    private _DeleteMessageProvider: MessageProvider

    constructor(a_TPMEventBO: TPMEventBO, a_TPMEventSpendRow: WB_TPM_EventSpendRow) {
        utils.eventify(this, undefined, undefined, true)
        this._OnLoadComplete = undefined
        this._bIsLoaded = false
        this._TPMEventBO = a_TPMEventBO
        this._TPMEventSpendRow = a_TPMEventSpendRow
        this._TPMEventSpendPropertyChanged = new BehaviorSubject<ITPMEventSpendChangedEvent>(undefined)
        this._ValidateMessageProvider = new MessageProvider()
        this._DeleteMessageProvider = new MessageProvider()

        this.ITPMEventSpendProductGroup_init()
        this.ITPMEventSpendProducts_init()
        this.IHaveSecurity_init()
        this.IHaveWorkflow_init()

    }


    get WB_EvtS_ID(): number {
        return this._TPMEventSpendRow.cif.WB_TEVTS_ID
    }

    get TPMEventSpendRow(): WB_TPM_EventSpendRow {
        return this._TPMEventSpendRow
    }

    get isActive(): boolean {
        return this._TPMEventSpendRow.isActive
    }

    get TPMEventBO(): TPMEventBO {
        return this._TPMEventBO
    }

    get TPMEventSpendPropertyChanged(): BehaviorSubject<ITPMEventSpendChangedEvent> {
        return this._TPMEventSpendPropertyChanged
    }

    get bCanDelete(): boolean {

        if (this.TPMEventBO.PolicyCollection && this.TPMEventBO.PolicyCollection.Event) {
            const evtPolicy: TPMEventBOStandardPolicy = this.TPMEventBO.PolicyCollection.Event
            if (!evtPolicy.bIsEditor) {
                return false
            }
        }

        // Check if Off Invoice, Post Approval, etc.
        if (this.PrimaryWorkflowProcessor && this.PrimaryWorkflowProcessor.CurrentState) {
            const currentState = this.PrimaryWorkflowProcessor.CurrentState
            if (currentState.StatusTypeIsPostApproval && (this.TPMEventSpendRow.cif.PAYMENT_METHOD == PaymentMethod_OffInvoice)) {
                return false
            }
        }

        if (this.TPMEventSpendRow.cif.ACTUAL_SPEND > 0.01) {
            return false
        }


        return true

    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded
    }

    markDeleted() {
        // This could check before deleting...
        this._TPMEventSpendRow.markDeleted()
    }

    get OnLoadComplete(): Promise<void> {
        const self = this
        if (!_.isUndefined(this._OnLoadComplete)) {
            return this._OnLoadComplete
        }

        const returnValue = (async () => {
            self.TPMEventSpendRow.setupOnChangeEvents([], self.ITPMEventSpend_onRecordChange.bind(self), self)
            await self.ITPMEventSpendProductGroup_OnLoadComplete()
            await self.ITPMEventSpendProducts_OnLoadComplete()
            await self.IHaveWorkflow_OnLoadComplete()
            await self.IHaveSecurity_OnLoadComplete()
            self._bIsLoaded = true
        })();

        this._OnLoadComplete = returnValue
        return returnValue
    }

    get ValidateMessageProvider(): IMessageProvider {
        return this._ValidateMessageProvider
    }

    get DeleteMessageProvider(): IMessageProvider {
        return this._DeleteMessageProvider
    }


    async Validate(options?: any): Promise<void> {
        const self = this

        self.ValidateMessageProvider.clearMessages()

        // Run Event Spend Validations
        await TPMEventSpendValidations.Validate(self)

        if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0)
            return

    }


    async ValidateBeforeDelete(options?: any): Promise<void> {
        const self = this

        self.DeleteMessageProvider.clearMessages()

        await TPMEventSpendValidations.ValidateBeforeDelete(self)

        if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0)
            return

    }


    private ITPMEventSpend_onRecordChange(record: WB_TPM_EventSpendRow, propertyName: string, propertyValue: any, options: TPMEventSpend) {
        this.TPMEventSpendPropertyChanged.next({
            TPMEventSpend: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }


    //<editor-fold desc="ITPMEventSpendProductGroup">

    private _TPMEventSpendProductGroupCollectionChanged: BehaviorSubject<ITPMEventSpendProductGroups>;
    private _TPMEventSpendProductGroupPropertyChanged: BehaviorSubject<ITPMEventSpendProductGroupChangedEvent>;

    ITPMEventSpendProductGroup_init() {
        this._TPMEventSpendProductGroupCollectionChanged = new BehaviorSubject<ITPMEventSpendProductGroups>(this)
        this._TPMEventSpendProductGroupPropertyChanged = new BehaviorSubject<ITPMEventSpendProductGroupChangedEvent>(undefined)
    }

    private async ITPMEventSpendProductGroup_OnLoadComplete(): Promise<void> {
        const self = this

        _.forEach(self.TPMEventSpendRow.WB_TPM_EventSpendPrdGrpRows, (aRow) => {
            aRow.setupOnChangeEvents([], self.ITPMEventSpendProductGroup_onRecordChange.bind(self), self)
        })
    }


    get TPMEventSpendProductGroupCollectionChanged(): BehaviorSubject<ITPMEventSpendProductGroups> {
        return this._TPMEventSpendProductGroupCollectionChanged
    }

    get TPMEventSpendProductGroupPropertyChanged(): BehaviorSubject<ITPMEventSpendProductGroupChangedEvent> {
        return this._TPMEventSpendProductGroupPropertyChanged
    }

    addTPMEventSpendProductGroup(wb_prdgrp_id: number | number[], options: ITPMEventSpendProductGroupsAddOptions): Promise<WB_TPM_EventSpendPrdGrpRow[]> {
        const self = this

        return new Promise<WB_TPM_EventSpendPrdGrpRow[]>((resolve, error) => {
            const opts = options || {}
            let pgRows: WB_ProductGroupRow[] = []
            const newRows: WB_TPM_EventSpendPrdGrpRow[] = []
            let arrWB_PrdGrp_ID: number[] = []
            if (_.isArray(wb_prdgrp_id)) {
                arrWB_PrdGrp_ID = wb_prdgrp_id
            } else {
                arrWB_PrdGrp_ID = [wb_prdgrp_id]
            }
            let sInclude = '1'
            if (_.isBoolean(opts.bInclude) && !opts.bInclude) {
                sInclude = '0'
            }

            const dbContext = self.TPMEventBO.dbContext

            dbContext.findUsingCache(esWB_Product_Group, arrWB_PrdGrp_ID)
                .then((aPGRows: WB_ProductGroupRow[]) => {
                    //
                    if (_.isEmpty(aPGRows)) {
                        resolve([])
                        return
                    }
                    pgRows = aPGRows

                    async function createRows() {
                        for (let idx = 0; idx < pgRows.length; idx++) {
                            const pgRow = pgRows[idx]
                            const aNewRow = <WB_TPM_EventSpendPrdGrpRow>await dbContext.createRecordWithKey(esWB_TPM_Event_Spend_Product_Group)
                            aNewRow.setDefaults()
                            aNewRow.cif.WB_TEVTS_ID = self.TPMEventSpendRow.cif.WB_TEVTS_ID
                            aNewRow.cif.WB_PRDGRP_ID = pgRow.cif.WB_PRDGRP_ID
                            aNewRow.cif.ROW_TYPE = 'ProductGroup'
                            aNewRow.cif.INCLUDE_IND = sInclude
                            dbContext.add(esWB_TPM_Event_Spend_Product_Group, aNewRow)
                            newRows.push(aNewRow)
                        }
                        return
                    }

                    return createRows()

                })
                .then((ignore) => {
                    if (_.isEmpty(newRows)) {
                        resolve([])
                        return
                    }

                    _.forEach(newRows, (aRow) => {
                        aRow.setupOnChangeEvents([], self.ITPMEventSpendProductGroup_onRecordChange.bind(self), self)
                    })

                    self.TPMEventSpendProductGroupCollectionChanged.next(self)
                    resolve(newRows)
                })
                .catch((err) => {
                    error(err)
                })

        })

    }

    removeTPMEventSpendProductGroupRow(wb_tevtspg_id: number | number[], options: any): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            let arraWB_TEVTSPG_IDs: number[] = []

            if (_.isArray(wb_tevtspg_id)) {
                arraWB_TEVTSPG_IDs = wb_tevtspg_id
            } else {
                arraWB_TEVTSPG_IDs = [wb_tevtspg_id]
            }

            // Check canRemove ?

            const arrPGRows = _.filter(self.TPMEventSpendRow.WB_TPM_EventSpendPrdGrpRows,
                (aRow: WB_TPM_EventSpendPrdGrpRow) => (aRow.isActive && (aRow.cif.OES_SENT_TO_IND != '1') && _.includes(arraWB_TEVTSPG_IDs, aRow.cif.WB_TEVTSPG_ID)))

            _.forEach(arrPGRows, (aRow: WB_TPM_EventSpendPrdGrpRow) => {
                aRow.markDeleted()
            })

            // Refresh the Spend Product Groups..
            self.TPMEventSpendProductGroupCollectionChanged.next(self)
            resolve()

        })
    }

    canRemoveTPMEventSpendProductGroupRow(wb_tevtspg_id: number): boolean {
        const self = this

        const arrPGRows = _.filter(self._TPMEventSpendRow.WB_TPM_EventSpendPrdGrpRows,
            (aRow: WB_TPM_EventSpendPrdGrpRow) => (aRow.isActive && (aRow.cif.OES_SENT_TO_IND != '1') && (aRow.cif.WB_TEVTSPG_ID == wb_tevtspg_id)))

        return (arrPGRows.length > 0)
    }


    private ITPMEventSpendProductGroup_onRecordChange(record: WB_TPM_EventSpendPrdGrpRow, propertyName: string, propertyValue: any, options: TPMEventSpend) {
        this.TPMEventSpendProductGroupPropertyChanged.next({
            TPMEventSpend: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }

    //</editor-fold>


    //<editor-fold desc = "ITPMEventSpendProducts operations">


    private _TPMEventSpendProductCollectionChanged: BehaviorSubject<ITPMEventSpendProducts>;
    private _TPMEventSpendProductPropertyChanged: BehaviorSubject<ITPMEventSpendProductChangedEvent>;

    private ITPMEventSpendProducts_init() {
        this._TPMEventSpendProductCollectionChanged = new BehaviorSubject<ITPMEventSpendProducts>(this)
        this._TPMEventSpendProductPropertyChanged = new BehaviorSubject<ITPMEventSpendProductChangedEvent>(undefined)
    }


    private ITPMEventSpendProducts_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(self.TPMEventSpendRow.WB_TPM_EventSpendPrdRows, (aRow) => {
                aRow.setupOnChangeEvents([], self.ITPMEventSpendProduct_onRecordChange.bind(self), self)
            })
            resolve()
        })
    }

    private ITPMEventSpendProduct_onRecordChange(record: WB_TPM_EventSpendPrdRow, propertyName: string, propertyValue: any, options: TPMEventSpend) {
        this.TPMEventSpendProductPropertyChanged.next({
            TPMEventSpend: options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }


    get TPMEventSpendProductCollectionChanged(): BehaviorSubject<ITPMEventSpendProducts> {
        return this._TPMEventSpendProductCollectionChanged
    }

    get TPMEventSpendProductPropertyChanged(): BehaviorSubject<ITPMEventSpendProductChangedEvent> {
        return this._TPMEventSpendProductPropertyChanged
    }

    addTPMEventSpendProduct(wb_prod_id: number | number[], options: ITPMEventSpendProductsAddOptions): Promise<WB_TPM_EventSpendPrdRow[]> {
        const self = this
        const opts: ITPMEventSpendProductsAddOptions = {}
        _.defaults(opts, options, ITPMEventSpendProductsAddOptionsDefaults)

        return new Promise<WB_TPM_EventSpendPrdRow[]>((resolve, error) => {

            let prdRows: WB_FinishedProductRow[] = []
            const newRows: WB_TPM_EventSpendPrdRow[] = []
            let arrWB_Prod_ID: number[] = []
            if (_.isArray(wb_prod_id)) {
                arrWB_Prod_ID = wb_prod_id
            } else {
                arrWB_Prod_ID = [wb_prod_id]
            }

            const dbContext = self.TPMEventBO.dbContext

            dbContext.findUsingCache(esWB_Finished_Product, arrWB_Prod_ID)
                .then((aPrdRows: WB_FinishedProductRow[]) => {
                    //
                    if (_.isEmpty(aPrdRows)) {
                        resolve([])
                        return
                    }
                    prdRows = aPrdRows

                    async function createRows() {
                        for (let idx = 0; idx < prdRows.length; idx++) {
                            const prdRow = prdRows[idx]
                            const aNewRow = <WB_TPM_EventSpendPrdRow>await dbContext.createRecordWithKey(esWB_TPM_Event_Spend_Product)
                            aNewRow.setDefaults()
                            aNewRow.cif.WB_TEVTS_ID = self.TPMEventSpendRow.cif.WB_TEVTS_ID
                            aNewRow.cif.WB_PROD_ID = prdRow.cif.WB_PROD_ID
                            aNewRow.WB_ProductRow = prdRow
                            // RowTypes defined in EvtProductRowType
                            if (!_.isEmpty(opts.RowType)) {
                                aNewRow.cif.ROW_TYPE = opts.RowType
                            } else {
                                if (prdRow.cif.PRODUCT_SET_ID == 'UPC') {
                                    aNewRow.cif.ROW_TYPE = 'Consumer'
                                } else { // TODO: Add Display Case
                                    aNewRow.cif.ROW_TYPE = 'Finished'
                                }
                            }
                            aNewRow.cif.PARENT_ROW_ID = opts.ParentRowId || 0
                            dbContext.add(esWB_TPM_Event_Spend_Product, aNewRow)
                            newRows.push(aNewRow)
                        }
                        return
                    }

                    return createRows()

                })
                .then((ignore) => {
                    if (_.isEmpty(newRows)) {
                        resolve([])
                        return
                    }

                    _.forEach(newRows, (aRow) => {
                        aRow.setupOnChangeEvents([], self.ITPMEventSpendProduct_onRecordChange.bind(self), self)
                    })

                    // TODO : Call Standard Calculator if needed
                    return ASync.resolve()
                })
                .then((ignore: any) => {
                    self.TPMEventSpendProductCollectionChanged.next(self)
                    resolve(newRows)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    canRemoveTPMEventSpendProductRow(wb_tevtsprd_id: number): boolean {
        const self = this


        const arrPrdRows: WB_TPM_EventSpendPrdRow[] = _.filter(self.TPMEventSpendRow.WB_TPM_EventSpendPrdRows,
            (aRow: WB_TPM_EventSpendPrdRow) => (aRow.cif.WB_TEVTSPRD_ID == wb_tevtsprd_id))

        //aRow.isActive && (aRow.cif.OES_SENT_TO_IND != '1') &&
        const aRow = arrPrdRows[0]
        if (aRow.isActive && (aRow.cif.OES_SENT_TO_IND != '1') && (aRow.cif.PARENT_ROW_ID != 0)) {
            return true
        }

        return false
    }

    removeTPMEventSpendProductRow(wb_tevtsprd_id: number | number[]): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            let arrWB_TEVTPRD_ID: number[] = []

            if (_.isArray(wb_tevtsprd_id)) {
                arrWB_TEVTPRD_ID = wb_tevtsprd_id
            } else {
                arrWB_TEVTPRD_ID = [wb_tevtsprd_id]
            }

            const arrPrdRows = _.filter(self.TPMEventSpendRow.WB_TPM_EventSpendPrdRows,
                (aRow: WB_TPM_EventSpendPrdRow) => (aRow.isActive && (aRow.cif.OES_SENT_TO_IND != '1') && _.includes(arrWB_TEVTPRD_ID, aRow.cif.WB_TEVTSPRD_ID)))

            _.forEach(arrPrdRows, (aRow: WB_TPM_EventSpendPrdRow) => {
                aRow.markDeleted()
            })

            self.TPMEventSpendProductCollectionChanged.next(self)
            resolve()
        })
    }


    //</editor-fold>

    //<editor-fold desc = "IHaveWorkflow operations">

    private _WorkflowProcessors: IWorkflowProcessor[]
    private _PrimaryWorkflowProcessor: IWorkflowProcessor


    private IHaveWorkflow_init(): void {
        this._WorkflowProcessors = []
        this._PrimaryWorkflowProcessor = undefined
    }

    private IHaveWorkflow_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            // Reset Workflow Processors

            self._WorkflowProcessors = []
            const aWorkflowProcessor
                = new WorkflowProcessor(self.TPMEventSpendRow.WB_TPM_EventSpendTypeRow.cif.WB_WORKFLOW_ID,
                {
                    dbContext: self.TPMEventBO.dbContext,
                    AppMgr_Id: 'EventSpend',
                    WB_App_Id: self.TPMEventSpendRow.cif.WB_TEVTS_ID,
                    App_Id: self.TPMEventSpendRow.cif.EVENT_SPEND_ID,
                    bLoadWorkflowHistory: true,
                    bLoadUserReviewers: false,
                    WB_Cust_Id: self.TPMEventBO.WB_TPMEvent.cif.WB_CUST_ID_PLANNING,
                    object: self,
                    Record: self.TPMEventSpendRow,
                    CurrentStateIdFieldName: 'WB_STATUS_ID',
                    NextStateIdFieldName: 'WB_STATUS_ID_NEXT'
                })

            const StdExtension = new TPMEventBOStandardSpendWorkflowExtension(self.TPMEventBO, self)
            aWorkflowProcessor.setExtensions([StdExtension])
            self._PrimaryWorkflowProcessor = aWorkflowProcessor
            self.PolicyCollection.addPolicy("Workflow", aWorkflowProcessor)

            aWorkflowProcessor.OnLoadComplete
                .then((ignore) => {
                    self._WorkflowProcessors.push(aWorkflowProcessor)
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    private IHaveWorkflow_BeforeReload(): void {
        this._WorkflowProcessors = []
        this._PrimaryWorkflowProcessor = undefined
    }

    get WorkflowProcessors(): IWorkflowProcessor[] {
        return this._WorkflowProcessors
    }

    get PrimaryWorkflowProcessor(): IWorkflowProcessor {
        return this._PrimaryWorkflowProcessor
    }


    //</editor-fold>


    //<editor-fold desc = "IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection;
    private _bIHaveSecurityLoaded: boolean;
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection()
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_BeforeReload() {
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this)
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded
        }


        this._OnIHaveSecurityLoaded = new Promise<IHaveSecurity>((resolve, error) => {
            const aStdSpendPolicy = new TPMEventBOStandardSpendPolicy(self)
            aStdSpendPolicy.OnLoadComplete
                .then((ignore) => {
                    self.PolicyCollection.addPolicy("Spend", aStdSpendPolicy)
                    this._bIHaveSecurityLoaded = true
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })

        return this._OnIHaveSecurityLoaded
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded
    }

    //</editor-fold>

}
